/* eslint-disable */

import PARSE from "html-react-parser";
import Moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { Skeleton } from "@mui/material";
import GlobalApi from "../../context/api/GlobalApi";
import Api from "./Api";

function SSoft_Blog_Detail() {
  const currentPath = window.location.href;
  const [article, setArticle] = useState();
  const [articleContent, setArticleContent] = useState();
  // const [url, setUrl] = useState('')
  const [sections, setSections] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const paramID = useParams();
  const navigate = useNavigate();

  const activeLang = useSelector((state) => state.content.activeLanguage);

  const getSectionsDetail = useCallback(() => {
    const api = new Api();
    api
      .getSectionDetail({ language: activeLang })
      .then((res) => {
        if (res.status === 200 && res.data.results) {
          const sectionFill = res.data.results;
          // setArticleCount(res.data.count);
          setSections(sectionFill);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, [activeLang]);

  useEffect(() => {
    getSectionsDetail();
  }, [getSectionsDetail]);

  const getDetailArticle = useCallback(() => {
    const api = new GlobalApi();
    api
      .getArticleDetailNew({ id: paramID.param1, all_languages: "False" })
      .then((res) => {
        setArticle(res.data);
        const { article_languages } = res.data;
        setArticleContent(article_languages);
        setIsFetching(false);
      })
      .catch((err) => {
        console.log("err", err);
        setIsFetching(false);
      });
  }, [paramID.param1]);

  useEffect(() => {
    getDetailArticle();
  }, [activeLang, getDetailArticle]);

  let text;

  if (sections) {
    const sec = sections[0]?.widgets;
    // const sec = sections;
    if (sec && sec.length !== 0) {
      sec.forEach((section, i) => {
        switch (i) {
          case 0:
            const textData = section.widget_contents;
            if (textData && textData.length > 0) {
              text = textData || { content: "" };
            }
            break;

          default:
            break;
        }
      });
    }
  }

  const fliterLangKey = article?.article_keywords?.filter(
    (key) => key?.language?.id === activeLang
  );

  const videoEl = useRef(null);

  if (isFetching)
    return (
      <div className="h-full max-w-[800px] mx-auto mt-[80px] px-8">
        <div className="">
          <h1 className="font-inter-bold text-[28px]">
            <Skeleton />
          </h1>
          <Skeleton />
          {articleContent?.path && (
            <div className="mt-[15px]  ">
              <Skeleton />
            </div>
          )}
        </div>
        <div className="mt-[45px]">
          <Skeleton variant="rect" width="100%" height={350} />
        </div>
        <div className="typo-style">
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    );
  return !isFetching && sections && sections.length > 0 && article ? (
    <>
      {articleContent?.title && (
        <Helmet>
          <meta name="description" content={articleContent.description} />
          <meta
            name="keywords"
            content={fliterLangKey?.map((key) => key?.keyword?.name)}
          />
          <title>{articleContent.title}</title>
          <link rel="canonical" href={currentPath} />
        </Helmet>
      )}
      <div className="section-container section-margin-x py-[90px] mt-[78px]">
        <div className="relative z-[-1] bg-[#1a2bs35] rounded-[20px] xl:pb-[40px] mdl:pb-[160px] pb-[120px] px-[40px] pt-[40px] mdl:p-[60px] h-[400px] flex items-center">
          <div
            className="absolute inset-0 rounded-[20px] z-[-1] bg-cover bg-center w-full"
            style={{
              backgroundImage: `url(https://bzpublishassets.blob.core.windows.net/media/assets/servicesbg.jpg)`,
            }}
          />
          <div className="space-y-[16px]">
            <p className="content-header-style-non-hero !text-white">
              {" "}
              {text[0]?.content}
            </p>

            <h1 className="text-white header-style-hero">
              {articleContent?.title}
            </h1>

            <div className="flex flex-wrap space-x-1 !mt-4">
              {article?.categories?.map((cat) => (
                <p
                  key={cat?.id}
                  className="text-xs font-inter h-fit rounded bg-newDarkBlue text-white px-1 w-fit"
                >
                  {cat?.name}
                </p>
              ))}
            </div>
          </div>
        </div>
        <div className="h-full max-w-[800px] mx-auto mt-[80px] ">
          <div className="">
            {/* <h1 className="font-inter-bold text-[28px]">
              {articleContent && articleContent.title}
            </h1> */}

            {articleContent?.path && (
              <div className="mt-[15px]  ">
                <div className="inline-flex font-inter-bold">{`${text[0]?.content} : `}</div>
                <a
                  className=""
                  href={articleContent?.path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {` ${articleContent?.path}`}
                </a>
              </div>
            )}
          </div>
          <div className="mt-[45px]">
            <img
              src={article?.article_assets[0]?.asset?.file_medium}
              alt={article?.article_assets[0]?.asset?.description}
              title={article?.article_assets[0]?.asset?.description}
              className="w-full rounded-[20px]"
            />
            <div className="space-y-2 flex items-center ">
              {/* <div className="flex flex-wrap space-x-1 !mt-4">
                {article?.categories?.map((cat) => (
                  <p
                    key={cat?.id}
                    className="text-xs font-inter h-fit rounded bg-newDarkBlue text-white px-1 w-fit"
                  >
                    {cat?.name}
                  </p>
                ))}
              </div> */}
            </div>
          </div>
          <div className="content-subheader-style-non-hero mt-[45px]">
            <p className="!font-inter-bold mb-[15px]">
              {article && Moment(article.date).format("DD MMMM YYYY")}
            </p>
            {articleContent?.content && PARSE(articleContent?.content)}
          </div>
          {article?.article_assets.length > 1 && (
            <video
              style={{
                backgroundColor: "black",
                maxWidth: "100%",
                maxHeight: "100%",
                width: "100%",
                height: "550px",
              }}
              controls
              alt="All the devices"
              ref={videoEl}
            >
              <source
                src={article?.article_assets[1]?.asset?.asset_file}
                type="video/mp4"
              />
            </video>
          )}
          <button className="border-2  p-2 mt-4" onClick={() => navigate(-1)}>
            {text[1]?.content}
          </button>
        </div>
      </div>
    </>
  ) : (
    !isFetching && !article && ""
  );
}

export default SSoft_Blog_Detail;
